import { Options, LabelType } from 'ng5-slider';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CrudService, MessageService, Search, Page } from 'elbuild-ui-lib-core';
import { forkJoin } from 'rxjs';
import { Building, Buildinglog } from 'toolbandi-ui-lib';

@Component({
	selector: 'app-building-activity-use',
	templateUrl: './building-activity-use.component.html',
	styleUrls: ['./building-activity-use.component.scss']
})
export class BuildingActivityUseComponent implements OnInit {

	@Input() building: Building;
	buildinglogs: Buildinglog[];

	constructor(private crudService: CrudService<Buildinglog>,
		private messageService: MessageService,
		private translateService: TranslateService) { }

		ngOnInit() {
			if (this.building) {
				this.loadBuildinglogs();
			}
		}

		getSliderDayOptions(item: Buildinglog): Options {
			return {
				floor: 0,
				ceil: item.maxdays,
			};
		}

		getSliderPercOptions(item: Buildinglog): Options {
			return {
				floor: 0,
				ceil: 100,
				translate: (value: number, label: LabelType): string => `${value} %`
			};
		}

		loadBuildinglogs() {
			const search = new Search(Buildinglog.TABLE);
			search.addSimpleFilter('buildingid', this.building.id);
			this.crudService.searchEntities(Buildinglog, Buildinglog.TABLE, search, new Page(100)).subscribe(result => {
				this.buildinglogs = result;
			}, error => {
				this.messageService.sendError(error.error.msg);
			});
		}

		save() {
			const calls = this.buildinglogs.map(tl => {
				if ( tl.days > tl.maxdays || tl.days < 0 || tl.useprecentage < 0 || tl.useprecentage > 100 ) {
					this.messageService.sendError(this.translateService.instant('labels.input-value-error'));
					throw new Error('Invalid input');
				}
				return this.crudService.saveEntity(Buildinglog, Buildinglog.TABLE, tl);
			});
			forkJoin(calls).subscribe(result => {
				console.log(result);
				this.messageService.sendSuccess(this.translateService.instant('labels.info-saved'), this.translateService.instant('labels.building-use'));
			}, error => {
				this.messageService.sendError(error.error.msg);
			});
		}

	}

